import { render } from "./PrintCourseForm.vue?vue&type=template&id=561547c6"
import script from "./PrintCourseForm.vue?vue&type=script&lang=js"
export * from "./PrintCourseForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/poshakjojomama-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__